<template>
  <section class="section section-lg section-shaped overflow-hidden my-0">
    <div class="shape shape-style-1 shape-primary shape-skew">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
    <div class="container py-0 pb-sm">
      <div class="row justify-content-between align-items-center">
        <div class="col-lg-5 mb-5 mb-lg-0">
          <h1 class="text-dark font-weight-bold">DEREGLE ELEMENTS</h1>
          <ul class="list-group pb-3">
            <li class="list-group-item bg-transparent border-0 pl-0 py-2">
              <u class="font-weight-bold text-normal"
                >E- WATER皮膚創傷能量修復水</u
              >
            </li>
            <li class="list-group-item bg-transparent border-0 pl-0 py-2">
              <u class="font-weight-bold text-normal"
                >E- CLEANSER負離子能量潔面乳</u
              >
            </li>
            <li class="list-group-item bg-transparent border-0 pl-0 py-2">
              <u class="font-weight-bold text-normal">E- ESSENCE保濕修護精華</u>
            </li>
            <li class="list-group-item bg-transparent border-0 pl-0 py-2">
              <u class="font-weight-bold text-normal">緊致豐盈乳霜</u>
            </li>
          </ul>
          <div class="btn-wrapper">
            <base-button
              tag="a"
              href="#product"
              class="mb-3 mb-sm-0"
              type="white"
              icon="fa fa-arrow-down"
            >
              瀏覽所有產品
            </base-button>
          </div>
        </div>
        <div class="col-lg-6 mb-lg-auto">
          <div
            class="
              rounded
              shadow-lg
              overflow-hidden
              transform-perspective-right
            "
          >
            <b-carousel id="carousel1" controls indicators>
              <!-- Text slides with image -->
              <b-carousel-slide img-src="img/main/bannerC.png" />
              <b-carousel-slide img-src="img/main/bannerB.png" />
              <b-carousel-slide img-src="img/main/bannerA.png" />
            </b-carousel>
          </div>
        </div>
      </div>
    </div>

    <section class="section section-lg pt-lg-0">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid product-list">
              <div class="col-lg-4 mt-1 mt-md-4" v-for="item in productlist" :keys="'product-id' + item.id">
                <card class="border-0" hover shadow body-classes="py-4">
                  <h6 class="text-primary text-uppercase d-flex justify-content-between">{{ item.desc }}<span>${{ item.price }}</span></h6>
                  <div class="img-wrap"><img :src="`img/main/product/${item.imgurl}`" class="img-fluid" /></div>
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>
<script>
import { BCarousel } from "bootstrap-vue/esm/components/carousel/carousel";
import { BCarouselSlide } from "bootstrap-vue/esm/components/carousel/carousel-slide";

export default {
  components: {
    BCarousel,
    BCarouselSlide,
  },
  data() {
    return {
      productlist: [
        { id: 1, imgurl: 'p1.png', price: '218' ,desc: 'E- WATER皮膚創傷能量修復水'},
        { id: 2, imgurl: 'p2.jpg', price: '238' ,desc: 'E- CLEANSER負離子能量潔面乳'},
        { id: 3, imgurl: 'p3.jpg', price: '288' ,desc: 'E- ESSENCE保濕修護精華'},
        { id: 4, imgurl: 'p4.jpg', price: '738' ,desc: '緊致豐盈乳霜'},
        { id: 5, imgurl: 'p5.jpg', price: '978' ,desc: 'DEREGLE ELEMENTS 護理系列'},
        { id: 6, imgurl: 'p6.jpg', price: '488' ,desc: 'E- WATER 補充裝'}
      ]
    }
  }
};
</script>

<style>
  .product-list .img-wrap{
    display: flex;
    align-items: center;
    min-height: 270px !important;
  }
</style>
